"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SliderComponent;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _rcSlider = _interopRequireDefault(require("rc-slider"));
require("rc-slider/assets/index.css");
var _sliderStyles = require("./sliderStyles");
require("./Slider.scss");
var _excluded = ["vertical", "reverse", "trackStyle", "handleStyle", "railStyle", "allScreen", "children"];
/* eslint-disable react/forbid-prop-types */
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function SliderComponent(_ref) {
  var vertical = _ref.vertical,
    reverse = _ref.reverse,
    trackStyle = _ref.trackStyle,
    handleStyle = _ref.handleStyle,
    railStyle = _ref.railStyle,
    allScreen = _ref.allScreen,
    children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var sliderClassName = (0, _classnames["default"])(allScreen && 'AllScreen');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Slider"
  }, children, /*#__PURE__*/_react["default"].createElement(_rcSlider["default"], _extends({
    vertical: vertical,
    reverse: reverse,
    trackStyle: _objectSpread(_objectSpread({}, _sliderStyles.sliderStyles.trackStyle), trackStyle),
    handleStyle: _objectSpread(_objectSpread({}, _sliderStyles.sliderStyles.handleStyle), handleStyle),
    railStyle: _objectSpread(_objectSpread({}, _sliderStyles.sliderStyles.railStyle), railStyle),
    className: sliderClassName
  }, restProps)));
}
SliderComponent.propTypes = {
  vertical: _propTypes["default"].bool,
  reverse: _propTypes["default"].bool,
  trackStyle: _propTypes["default"].object,
  handleStyle: _propTypes["default"].object,
  railStyle: _propTypes["default"].object,
  allScreen: _propTypes["default"].bool
};
SliderComponent.defaultProps = {
  vertical: false,
  reverse: false,
  trackStyle: {},
  handleStyle: {},
  railStyle: {},
  allScreen: false
};